import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import imagem1 from "../../images/imagem13.jpg";
import Globais from "../../css/Globais";
import familiaResort from "../../images/familia-resort.jpg";

const SectionWrapper = styled.section`
  background-color: #ffffff;
  padding: 4rem 1.5rem;

  @media (min-width: 768px) {
    padding: 6rem 4rem;
  }
`;

const Content = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 3rem;
  color: #222;
`;

const Cards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const Card = styled.div`
  background-color: #f9f9f9;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.03);
`;

const Quote = styled.p`
  font-size: 1.05rem;
  color: #444;
  font-style: italic;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const Author = styled.p`
  font-size: 0.95rem;
  color: #777;
  font-weight: 600;
`;


const ViewProvaSocial = () => {
  return (
    <SectionWrapper>
      <Content>
        <Title>Veja o que outros proprietários estão dizendo</Title>

        <Cards>
          <Card>
            <Quote>
              “Já tinha perdido duas semanas da minha cota.  
              Depois que anunciei aqui, consegui alugar uma e já recebi proposta pra outra.”
            </Quote>
            <Author>— João M., multiproprietário em Porto Seguro</Author>
          </Card>

          <Card>
            <Quote>
              “Consegui trocar minha semana com outro proprietário direto, sem depender do hotel.  
              Foi rápido e mais fácil do que eu imaginava. Além disso, mais seguro pois eles fazem contrato de locação.”
            </Quote>
            <Author>— Luciana R., multiproprietária em Gramado</Author>
          </Card>

          <Card>
            <Quote>
              “Achei que não ia conseguir vender minha cota nunca.  
              Anunciei aqui, em menos de 1 mês recebi proposta e estou em processo de transferência. Valeu cada centavo.”
            </Quote>
            <Author>— Carlos A., multiproprietário em Maceió</Author>
          </Card>
        </Cards>
      </Content>
    </SectionWrapper>
  );
};

export default ViewProvaSocial;




